<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_edit_user_information'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="170px" class="dialog-form-item">
                        <!--- ユーザーID --->
                        <el-form-item prop="userName" ref="userName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_userId'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_userId')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="userName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.userName.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                        <!--- ユーザー表示名 --->
                        <el-form-item prop="displayName" ref="displayName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_userDisplayName'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_user_display_name')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="displayName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="inputCheckAll()"/>
                        </el-form-item>
                        <!--- パスワード --->
                        <el-form-item prop="password" ref="password">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_password'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_password')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                                <span style="position:relative">
                                    <button class="input-pass-check" type="button" @click="handleChangePasswordCheck()">{{ passwordShowHideButton }}</button>
                                </span>
                            </div>
                            <el-input id="password" size="large" :type="inputTypeOfPassword" ref="password" v-model="inputForm.password.value" autocomplete="new-password"
                                 @input.native="inputCheck($event.target.id)" @clear="inputCheckAll()"/>
                        </el-form-item>

                        <template v-if="!isAdminUser">
                            <!--- 組織名 --->
                            <el-form-item prop="organization" ref="organization">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_organization'"/>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_searching_user_item')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-input id="organization" size="large" type="text" v-model="inputForm.organization.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="inputCheckAll()"/>
                            </el-form-item>
                            <!--- 役職名 --->
                            <el-form-item prop="title" ref="title">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_job_title'"/>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_searching_user_item')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-input id="title" size="large" type="text" v-model="inputForm.title.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="inputCheckAll()"/>
                            </el-form-item>
                            <!--- 電話番号 --->
                            <el-form-item prop="phoneNumber" ref="phoneNumber">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_tenant_phone'"/>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_user_phoneNumber')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-input id="phoneNumber" size="large" type="text" v-model="inputForm.phoneNumber.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="inputCheckAll()"/>
                            </el-form-item>
                            <!--- メールアドレス --->
                            <el-form-item prop="emailAddress" ref="emailAddress">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_tenant_email'"/>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_user_emailAddress')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-input id="emailAddress" size="large" type="text" v-model="inputForm.emailAddress.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="inputCheckAll()"/>
                            </el-form-item>
                            <!--- かんたんログイン --->
                            <el-form-item style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_easyLogin'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-t="'message.hint_easy_login'"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="userOptions.easyLogin" active-color="#5171cb" @change="handleOptionChange('easyLogin')"></el-switch>
                            </el-form-item>
                            <!--- かんたんログインQR表示 --->
                            <el-form-item style="text-align:right" label-width="280px">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_easyLogin_QR'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-t="'message.hint_easy_login_qr'"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="userOptions.showGroupUrl" active-color="#5171cb" @change="handleOptionChange('showGroupUrl')"></el-switch>
                            </el-form-item>
                            <!--- 割込み通話権限 --->
                            <el-form-item style="text-align:right" label-width="280px">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_interrupt_permission'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-t="'message.hint_option_interrupt_permission'"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="userOptions.interrupt" active-color="#5171cb" @change="handleOptionChange('interrupt')"></el-switch>
                            </el-form-item>
                            <!--- マップ通話オプション --->
                            <el-form-item style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_map_talk'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-t="'message.hint_option_map_talk'"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="userOptions.mapTalk" active-color="#5171cb" @change="handleOptionChange('mapTalk')"></el-switch>
                            </el-form-item>
                            <div v-if="showOptionSetting">
                            <!--- hide all options when online purchase / speech-to-text license not exist ---->
                            <!--- 有償オプション説明 --->
                            <p class="beside-line" v-t="'message.item_option'"></p>
                            <p class="option-description">
                                <span v-if="appData.basicContract.planType == 0" v-t="'message.hint_option_description1'"/>
                                <span v-else v-t="'message.hint_option_description1_plan'"/>
                                <br>
                                <span v-t="'message.hint_option_description6'"/><br>
                            </p>
                            <!--- 音声テキスト化オプション --->
                            <el-form-item v-if="isVisibleUserOption('speechToText')" style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_speechToText'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-t="'message.hint_option_speechToText'"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="userOptions.speechToText" active-color="#5171cb" @change="handleOptionChange('speechToText')"></el-switch>
                            </el-form-item>
                            <!--- 翻訳オプション --->
                            <el-form-item v-if="isVisibleUserOption('translation')" style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_translation'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_option_translation')" ></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="userOptions.translation" active-color="#5171cb" @change="handleOptionChange('translation')"></el-switch>
                            </el-form-item>
                            <!--- 動態管理オプション --->
                            <el-form-item v-if="isVisibleUserOption('tracking')" style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_location_tracking'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-t="'message.hint_option_location_tracking'"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="userOptions.tracking" active-color="#5171cb" @change="handleOptionChange('tracking')"></el-switch>
                            </el-form-item>
                            <!--- ライブキャストオプション --->
                            <el-form-item v-if="isVisibleUserOption('video')" style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_video'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-t="'message.hint_option_video'"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-switch v-model="userOptions.video" active-color="#5171cb" @change="handleOptionChange('video')"></el-switch>
                            </el-form-item>
                        </template>

                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.disableButton" @click="saveChange()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import characterCheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';

export default {
    data() {
        return {
            inputForm: {
                userName:     { validationRule:"userId",               valid:true, value:null, isComposing:false, requiredForAdmin:true  },
                displayName:  { validationRule:"reqDisplayName",       valid:true, value:null, isComposing:false, requiredForAdmin:true  },
                password:     { validationRule:"passwordNotRequired",  valid:true, value:null, isComposing:false, requiredForAdmin:true  },
                organization: { validationRule:"displayName",          valid:true, value:null, isComposing:false, requiredForAdmin:false },
                title:        { validationRule:"displayName",          valid:true, value:null, isComposing:false, requiredForAdmin:false },
                phoneNumber:  { validationRule:"phoneNumber",          valid:true, value:null, isComposing:false, requiredForAdmin:false },
                emailAddress: { validationRule:"userEmailAddress",     valid:true, value:null, isComposing:false, requiredForAdmin:false }
            },
            userOptions: {
                speechToText:   false,
                translation:    false,
                tracking:       false,
                mapTalk:        false,
                video:          false,
                easyLogin:      false,
                interrupt:      false,
                showGroupUrl:   false
            },
            inputTypeOfPassword: "password",
            passwordShowHideButton: "SHOW",
            disableButton: true,
        };
    },
    methods: {
        saveChange: function() {
            this.inputCheckAll();
            if (!commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = true;
                return;
            }

            let newUserOptions = {};
            if (this.userAttribute.userOptions.speechToText != this.userOptions.speechToText) {
                newUserOptions.speechToText = this.userOptions.speechToText;
            }
            if (this.userAttribute.userOptions.translation != this.userOptions.translation) {
                newUserOptions.translation = this.userOptions.translation;
            }
            if (this.userAttribute.userOptions.tracking != this.userOptions.tracking) {
                newUserOptions.tracking = this.userOptions.tracking;
            }
            if (this.userAttribute.userOptions.mapTalk != this.userOptions.mapTalk) {
                newUserOptions.mapTalk = this.userOptions.mapTalk;
            }
            if (this.userAttribute.userOptions.video != this.userOptions.video) {
                newUserOptions.video = this.userOptions.video;
            }
            if (this.userAttribute.userOptions.easyLogin != this.userOptions.easyLogin) {
                newUserOptions.easyLogin = this.userOptions.easyLogin;
            }
            if (this.userAttribute.userOptions.interrupt != this.userOptions.interrupt) {
                newUserOptions.interrupt = this.userOptions.interrupt;
            }
            if (this.userAttribute.userOptions.showGroupUrl != this.userOptions.showGroupUrl){
                newUserOptions.showGroupUrl = this.userOptions.showGroupUrl;
            }
            if (Object.keys(newUserOptions).length == 0) {
                newUserOptions = null;
            }

            let input = {}
            for (let key in this.inputForm) {
                if (this.isAdminUser) {
                    if (this.inputForm[key].requiredForAdmin) {
                        input[key] = this.inputForm[key].value
                    }
                } else {
                    input[key] = this.inputForm[key].value
                }
            }
            this.$emit('save', input, newUserOptions);
        },
        handleOptionChange: function(changedOption) {
            commonUtil.checkChangedUserOptionCondition(this, changedOption, this.appData, this.userOptions);
            this.setButtonStatus();
        },
        handleChangePasswordCheck() {
            if (this.inputTypeOfPassword == "password") {
                this.inputTypeOfPassword = "text";
            } else {
                this.inputTypeOfPassword = "password";
            }
        },
        setButtonStatus: function() {
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult;
            switch(eventTargetId) {
                case "phoneNumber":
                    validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value, this.appData.countryCodeAlpha3);
                    break;
                default:
                    validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
                    break;
            }
            if (validateResult.valid) {
                this.inputForm[eventTargetId].valid = true;
                this.$refs[eventTargetId].clearValidate();
            } else {
                this.inputForm[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        inputCheckAll() {
            for (let targetId in this.inputForm) {
                if (this.isAdminUser) {
                    if (this.inputForm[targetId].requiredForAdmin) {
                        this.inputCheck(targetId);
                    }
                } else {
                    this.inputCheck(targetId);
                }
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        isVisibleUserOption(optionName) {
            if (this.appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
                return commonUtil.isVisibleUserOption(this.appData.onlinePurchase, optionName);
            } else {
                return true;
            }
        }
    },
    created: function() {
        this.inputForm.userName.value = this.userAttribute.name;
        this.inputForm.displayName.value = this.userAttribute.displayName;
        if (!this.isAdminUser) {
            this.inputForm.organization = { validationRule: "displayName",      valid: true, value: this.userAttribute.organization,    isComposing: false  },
            this.inputForm.title        = { validationRule: "displayName",      valid: true, value: this.userAttribute.title,           isComposing: false  },
            this.inputForm.phoneNumber  = { validationRule: "phoneNumber",      valid: true, value: this.userAttribute.phoneNumber,     isComposing: false  },
            this.inputForm.emailAddress = { validationRule: "userEmailAddress", valid: true, value: this.userAttribute.emailAddress,    isComposing: false  },
            this.userOptions.speechToText = this.userAttribute.userOptions.speechToText;
            this.userOptions.translation = this.userAttribute.userOptions.translation;
            this.userOptions.tracking = this.userAttribute.userOptions.tracking;
            this.userOptions.mapTalk = this.userAttribute.userOptions.mapTalk;
            this.userOptions.video = this.userAttribute.userOptions.video;
            this.userOptions.easyLogin = this.userAttribute.userOptions.easyLogin;
            this.userOptions.interrupt = this.userAttribute.userOptions.interrupt;
            this.userOptions.showGroupUrl = this.userAttribute.userOptions.showGroupUrl;
        }
    },
    mounted: function() {
        // tabIndex of tooltip was always set to 0 (Should set -1 to skip focus)
        for (let element of document.getElementsByClassName('icon-help')) {
            element.setAttribute("tabIndex", "-1");
        }
    },
    watch: {
        inputTypeOfPassword(newVal) {
            if (newVal == "password") {
                this.passwordShowHideButton = "SHOW";
            } else {
                this.passwordShowHideButton = "HIDE";
            }
        }
    },
    computed: {
        showOptionSetting: function() {
            if (this.appData.onlinePurchase) {
                if (this.appData.basicContract.planType != constants.LICENSE_PLAN_SEPARATE) {
                    return true;
                } else {
                    if ((this.appData.enableSpeechTextOption) || (this.appData.enableSpeechTextTrial)) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return true;
            }
        }
    },
    props: {
        appData: Object,
        userAttribute: Object,
        talkgroupInfos: Object,
        isAdminUser: {
            type: Boolean,
            default: false
        }
    }
}
</script scoped>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 305px;
    top: 2px;
    z-index: 10;
    color: #848991;
    font-size: 10px;
}
</style>
